import type { ReactNode } from 'react';

export const symbol_tooltip: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-237q-24.75 0-42.37-17.63Q80-272.25 80-297v-523q0-24.75 17.63-42.38Q115.25-880 140-880h680q24.75 0 42.38 17.62Q880-844.75 880-820v523q0 24.75-17.62 42.37Q844.75-237 820-237H584l-79 119q-5 7-11 10.5t-14 3.5q-8 0-14-3.5T455-118l-79-119H140Zm340 49 72-109h268v-523H140v523h268l72 109Zm0-371Z"
		/>
	</svg>
);
